import { Effect, pipe } from "effect";
import { CmcToken, CmcTokenMeta } from "../cmc-client/types";
import { KvClientError, KvService } from "./types";
import { getTokenCmcMetaKey } from "./keys";
import { Schema } from "@effect/schema";

export type SetCmcMeta = ReturnType<typeof setCmcMeta>;
export type SetCmcMetaSuccess = Effect.Effect.Success<SetCmcMeta>;
export type SetCmcMetaError = Effect.Effect.Error<SetCmcMeta>;
export type SetCmcMetaContext = Effect.Effect.Context<SetCmcMeta>;

export function setCmcMeta(tokens: CmcToken[]) {
  return Effect.gen(function* () {
    if (tokens.length === 0) return;

    const items = yield* Effect.all(
      tokens.map((token) =>
        pipe(
          token.meta,
          Schema.encode(CmcTokenMeta),
          Effect.andThen((encodedMeta) => ({ token, encodedMeta }))
        )
      )
    );

    const kv = yield* KvService;

    yield* Effect.tryPromise({
      try: async () => {
        const pipeline = kv.pipeline();

        for (const {
          token: { chainKey, tokenAddress },
          encodedMeta,
        } of items) {
          const key = getTokenCmcMetaKey(chainKey, tokenAddress);

          pipeline.json.set(key, "$", JSON.stringify(encodedMeta));
        }

        return pipeline.exec();
      },
      catch: (cause) => new KvClientError({ cause }),
    });
  });
}
